export function sortAreas(areas: Element[]) {
  areas.sort((a, b) => {
    const aSrcRect = a.getAttribute("src-rect") || "";
    let [x, y] = aSrcRect
      .split(" ")
      .filter((x) => x.length > 0)
      .map((x) => Number(x));
    const bSrcRect = b.getAttribute("src-rect") || "";
    let [bx, by] = bSrcRect
      .split(" ")
      .filter((x) => x.length > 0)
      .map((x) => Number(x));

    if (Math.round(y / 50) === Math.round(by / 50)) {
      return x - bx;
    } else {
      return y - by;
    }
  });
  return areas;
}



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/image/util/sort.ts